export const getCustomDynamicArray = (newDynamicFields, template) => {
    const getTemplateDynamicValues = checkCustomDynamicFields(template);

    return newDynamicFields
        .filter((item) => getTemplateDynamicValues.includes(item))
        .map(item => item.replace(/{{|}}/g, ''));
}

export const checkCustomDynamicFields = (template) => {
    const templateDynamicValues = [];
    const regex = /{{([^}]+)}}/g;
    let match;

    while((match = regex.exec(template)) !== null) {
        templateDynamicValues.push(`{{${match[1]}}}`);
    }

    return templateDynamicValues;
}